import React from 'react';
import PlayIcon from '@mui/icons-material/PlayCircle';
import Plyr from 'plyr';
import Hls from 'hls.js';
import 'plyr/dist/plyr.css';
import logo from '../assets/logo.png'
import { baseUrl, i, k } from '../constants';
import { Oval } from 'react-loader-spinner';

const _de = async (data, _k, _i) => {
    const cK = await crypto.subtle.importKey(
        'raw',
        _k,
        { name: 'AES-CBC' },
        false,
        ['decrypt']
    );
    try {
        const dd = await crypto.subtle.decrypt({
                name: 'AES-CBC',
                iv: _i,
            },
            cK,
            data
        );
        return dd;
    } catch (e) {
        // console.log('eee', e)
        return null
    }
}

const DE = async(data) => {

    const text_k = Uint8Array.from(atob(k), c => c.charCodeAt(0));
    const text_i = Uint8Array.from(atob(i), c => c.charCodeAt(0));
    const encodedText = Uint8Array.from(atob(window.hkeys), c => c.charCodeAt(0)); 
    let keys = await _de(encodedText, text_k, text_i)
    keys = new TextDecoder().decode(keys);
    keys = keys.split(';')
    const seg_k = Uint8Array.from(atob(keys[0]), c => c.charCodeAt(0));
    const seg_i = Uint8Array.from(atob(keys[1]), c => c.charCodeAt(0));
    return await _de(data, seg_k, seg_i)
    
}

class CustomFragmentLoader extends Hls.DefaultConfig.loader {
    constructor(config) {
        super(config);
        var load = this.load.bind(this);
        this.load = function(context, config, callbacks) {
            var onSuccess = callbacks.onSuccess;
            callbacks.onSuccess = async function(response, stats, context) {
                response.data = await DE(response.data);
                onSuccess(response, stats, context);
            };
            load(context, config, callbacks);
        };

    }

}


const Player = (props) => {
    const videoRef = React.useRef(null);
    const playerRef = React.useRef(null);
    const playRef = React.useRef(null);
    const { options, style } = props;
    const [player, setPlayer] = React.useState(null)
    const [started, setStarted] = React.useState(false)
    const [buffering, setBuffering] = React.useState(true)
    const loadingRef = React.useRef(null);

    const source = options.source.url
    let l = options.source.values
    l = l.split(';')[1]
    window.hkeys = l
    console.log(l)

    React.useEffect(() => {
        if (!videoRef.current || !source) return;

        let hls;
        const defaultOptions = {};

        if (Hls.isSupported()) {

            hls = new Hls({ fLoader: CustomFragmentLoader });
            hls.loadSource(source);
            hls.attachMedia(videoRef.current);
            
            hls.on(Hls.Events.ERROR, (event, data) => {
                console.error('HLS error:', data);
            });

            // videoRef.current.play()

            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                // Add quality levels to the Plyr settings menu
                    // player.on('ready', () => {
                console.log(hls.levels)

                const availableQualities = hls.levels.map((l) => l.height)
                availableQualities.unshift(0)

                // Add new qualities to option
                defaultOptions.quality = {
                        default: availableQualities[0],
                        options: availableQualities,
                        // this ensures Plyr to use Hls to update quality level
                        // Ref: https://github.com/sampotts/plyr/blob/master/src/js/html5.js#L77
                        forced: true,
                        onChange: (newQuality) => {
                            let ct = videoRef.current.currentTime;
                            if (newQuality == 0) {
                                hls.currentLevel = -1;
                                if (ct > 1) setTimeout(() => videoRef.current.currentTime -= 1, 500)
                            } else {
                                hls.levels.forEach((level, levelIndex) => {
                                    if (level.height === newQuality) {
                                        console.log("Found quality match with " + newQuality, hls.currentLevel, levelIndex, hls.setCurrentLevel);
                                        hls.currentLevel = levelIndex;
                                        if (ct > 1) setTimeout(() => videoRef.current.currentTime -= 1, 500)
                                    }
                                });
                            }
                        }
                    }
                    // Initialize new Plyr player with quality options
                    // const player = new Plyr(videoRef, defaultOptions);
                const plyr = new Plyr(videoRef.current, {
                    ...defaultOptions,
                    autoplay: false,
                    poster: baseUrl + options.source.thumbnail,
                    i18n: {
                        qualityLabel: {
                            0: 'Auto',
                        }
                    },
                    previewThumbnails: { enabled: true, src: baseUrl + options.source.previewThumbnail },
                    controls: [
                        'play',
                        'progress',
                        'current-time',
                        'mute',
                        'volume',
                        'captions',
                        'settings',
                        'pip',
                        'airplay',
                        'fullscreen'
                    ],
                });
                plyr.on('ready', (event) => {
                    // Example: Add a custom button to the controls
                    if (!document.getElementById('player-huluware')) {
                        const hulluimg = document.createElement('img');
                        hulluimg.id = 'player-huluware';
                        hulluimg.src = logo;
                        hulluimg.style.cssText = 'width: 35px; height: 45px; object-fit: contain;'
                        hulluimg.addEventListener('click', () => {
                            alert('Player Secured by HulluWare!');
                        });

                        // Append the custom button to the controls
                        const controlsContainer = document.querySelector('.plyr__controls');
                        if (controlsContainer) controlsContainer.appendChild(hulluimg);
                    }

                })

                plyr.on('waiting', () => {
                    if (loadingRef.current) {
                        loadingRef.current.style.display = 'flex'
                    }
                })

                plyr.on('canplay', () => {
                    if (loadingRef.current) {
                        loadingRef.current.style.display = 'none'
                    }
                })

                plyr.on('play', () => {
                    if (playRef.current) {
                        playRef.current.style.display = 'none'
                    }
                })

                plyr.poster = baseUrl + options.source.thumbnail
                setPlayer(plyr)

            });
        } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
            videoRef.current.src = source;
        } else {
            console.error('HLS is not supported in this browser.');
        }

        return () => {
            if (hls) {
                hls.destroy();
            }
        };
    }, [source]);

    const play = () => {
        if (player) {
            player.play()
        }
    }

  return (
      <div style={{
        width: '100%',
        maxWidth: '960px',
        aspectRatio: '16 / 9',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div ref={playRef} className='w-[80px] h-[80px] absolute'>
            <span class="bg-main w-[80px] h-[80px] animate-ping rounded-full absolute z-[999]"></span>
            <button onClick={play} className='bg-main w-[80px] h-[80px] rounded-full flex items-center justify-center absolute z-[9999] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]'>
                <PlayIcon style={{color: '#ffffff', fontSize: 70}}>Filled</PlayIcon>
            </button>
        </div>
        <div ref={loadingRef} className='absolute flex items-center justify-center z-[9999] bg-white rounded-full'>
            <Oval
                visible={true}
                height="80"
                width="80"
                color="#52a4e0"
                secondaryColor={'#ffffff'}
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
                strokeWidth={3}
            />
            <img src={logo} className='absolute w-[60px] h-[60px] object-contain'/>
        </div>
        <video style={{
          backgroundColor: '#000',
          width: '100%', height: '100%'
      }} ref={videoRef} controls crossOrigin="true" />
      </div>
  );
}

export default Player;